import { Component, OnInit, Output, EventEmitter, HostListener, ViewChild } from '@angular/core';
import { EmrPatAllVisitsService } from './emr-pat-all-visits.service';
import { UserSessionService } from '../../shared';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SelectizeComponent, ToastService } from '../../blocks';
import { MedicalRepositoryService } from '../medical-repository.service';
import { PatientVM } from '../../registeration/patients/patient';
import { EmrPatientParms } from '../medical-recored.interfaces';

@Component({
  selector: 'emr-pat-all-visits',
  templateUrl: './emr-pat-all-visits.component.html',
  styleUrls: ['./emr-pat-all-visits.component.css']
})
export class EmrPatAllVisitsComponent implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject<any>();
  @Output() closeAllVisits: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitPatVisitData: EventEmitter<PatientVM> = new EventEmitter<PatientVM>();
  @ViewChild('childServiceSelectize') selectizeChildService: SelectizeComponent;

  //properties
  allVisits: any[] = [];
  visitSerial: number;
  patCode: number;
  resourceType: number;
  isScrolling: boolean
  labData: any[] = [];
  radData: any[] = [];
  servicesData: any[] = [];
  medications: any[] = [];
  leads: any[] = [];
  diagnosis: any[] = [];
  complaints: any[] = [];
  finding: any[] = [];
  showMedicalData: boolean;


  constructor(
    private _allVisits: EmrPatAllVisitsService,
    private _uss: UserSessionService,
    private _medicalRepo: MedicalRepositoryService,
    private _toastr: ToastService,
    public translate: TranslateService) { }

  ngOnInit() {
    this._uss.subscribeToKey$('visitData')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (keys: any) => {
          if (keys && keys.value) {
            this.patCode = keys.value.patCode;
            this.resourceType = keys.value.resourceType;
            this.visitSerial = keys.value.serial
            this.getAllData();
            ///   this.getAllVisitsData(this.patCode);
          }
        },
        err => console.error(err)
      )
    this._uss.subscribeToKey$('patient')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (keys: any) => {
          if (keys && keys.value) {
            this.patCode = keys.value
            this.getAllData();
          }
        },
        err => console.error(err)
      )

  }
  vSerial: number
  getVisitSerial(ev: any) {
    if (ev && ev.code && !ev.AutoEmitted) {
      this.groupedMedications = this.groupByVisitSerial(this.medications.filter(medication => medication.visitSerial == ev.code));
      this.groupedDiagnosis = this.groupByVisitSerial(this.diagnosis.filter(diagnosis => diagnosis.visitSerial == ev.code));
      this.groupedVitals = this.groupByVisitSerial(this.vitals.filter(vital => vital.visitSerial == ev.code));
      this.groupedComplaints = this.groupByVisitSerial(this.complaints.filter(complaints => complaints.visitSerial == ev.code));
      this.groupedLabData = this.groupByVisitSerial(this.labData.filter(labData => labData.visitSerial == ev.code));
      this.groupedRadData = this.groupByVisitSerial(this.radData.filter(radData => radData.visitSerial == ev.code));
      this.groupedLeads = this.groupByVisitSerial(this.leads.filter(leads => leads.visitSerial == ev.code));
      this.groupedFinding = this.groupByVisitSerial(this.finding.filter(finding => finding.visitSerial == ev.code));
    }
  }
  getAllVisitsData(patCode: number) {
    this.allVisits = []
    if (patCode > 0 || this.visitSerial) {
      this._allVisits.getAllPatientVisits(<any>{ patCode: patCode, visitType: 2, visitSerial: this.visitSerial })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          res => {
            if (res && res.data) {
              this.allVisits = res.data;
              this.allServices = [];
              this.vitals = [];
              this.servicesData = [];
              this.medications = [];
              this.labData = [];
              this.radData = [];
              this.diagnosis = [];
              this.leads = [];
              this.complaints = [];
            }
          },
          err => console.error(err)
        )
    } else {
      this._toastr.activate('Please Select Patient First');
    }
  }

  // onRowClick(actionCode: number, visitData: any) {
  //   switch (actionCode) {
  //     case 404:
  //       this.showMedicalData = true;
  //       this.emitPatVisitData.emit(null)
  //       this.getAllMedicalData(visitData);
  //       break;
  //     case 2132:
  //       this.showMedicalData = false;
  //       this.emitPatVisitData.emit(visitData)
  //       break;

  //     default:
  //       this._toastr.activate('No Visit Selected', 'Attention');
  //       break;
  //   }
  // }
  //================================================================Eng/Mostafa Mahmoud =====================================================
  PatientParms: EmrPatientParms = <EmrPatientParms>{};
  toggleVisit: boolean = false;
  allServices: any[] = [];
  vitals: any[] = [];
  groupedComplaints: any[] = [];
  groupedRadData: any[] = [];
  groupedDiagnosis: any[] = [];
  groupedVitals: any[] = [];
  groupedFinding: any[] = [];
  groupedLabData: any[] = [];
  groupedMedications: any[] = [];
  groupedLeads: any[] = [];
  restArr() {
    // this.selectizeChildService.clear();
    this.vSerial = 0
    this.groupedComplaints = [];
    this.groupedDiagnosis = [];
    this.groupedVitals = [];
    this.groupedLabData = [];
    this.groupedRadData = [];
    this.groupedMedications = [];
    this.groupedLeads = [];
    this.servicesData = [];
    this.medications = [];
    this.labData = [];
    this.radData = [];
    this.diagnosis = [];
    this.leads = [];
    this.complaints = [];
    this.allServices = [];
    this.vitals = [];
  }
  getAllData(PatientParms?: any) {
    this.restArr()
    this.PatientParms.visitFilter = 0;
    if (PatientParms) {
      this.patCode = PatientParms.patCode
      this.visitSerial = PatientParms.visitSerial
    }
    this.PatientParms.visitSerial = this.visitSerial;
    this.PatientParms.patCode = this.patCode;
    this.PatientParms.serviceType = 0;
    this.PatientParms.flag = 1;
    this.PatientParms.userTabs = 'ORDERS,MEDICATION,Leads,Diagnois,Complains,Finding,Vitals';
    this.PatientParms.resourceType = this.resourceType;
    this._allVisits.getEmrDoctorsData(this.PatientParms)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res) {
            this.vitals = res['data1'];
            this.allServices = res['data10'];
            this.servicesData = res['data10'];
            this.finding = res['data14'];
            this.leads = res['data41'];
            this.medications = res['data16'];
            this.diagnosis = res['data8'];
            this.complaints = res['data6'];
            this.patCode = res['data10'].patientCode ? res['data10'].patientCode : this.patCode;
          }
        },
        err => console.error(err),
        () => {
          if (this.allServices) {
            this.labData = this.allServices.filter(el => el.serviceType == 1);
          }
          if (this.servicesData) {
            this.radData = this.servicesData.filter(el => el.serviceType == 2);
          }
          this.toggleVisit = true
          this.onShowAllVisitChange()
        }
      )
  }

  groupByVisitSerial(Data: any[]): any[] {
    return Data.reduce((grouped, item) => {
      const existingGroup = grouped.find(group => group.visitSerial === item.visitSerial);
      if (existingGroup) {
        existingGroup.items.push(item);
      } else {
        grouped.push({ visitSerial: item.visitSerial, specialtyNameAr: item.specialtyNameAr, specialtyNameEn: item.specialtyNameEn, visitNo: item.visitNo, regDate: item.regDate, items: [item] });
      }
      return grouped;
    }, []);
  }
  onShowAllVisitChange() {
    this.toggleVisit = !this.toggleVisit;
    if (this.toggleVisit == true) {
      this.groupedMedications = this.groupByVisitSerial(this.medications.filter(medication => medication.visitSerial == this.visitSerial));
      this.groupedDiagnosis = this.groupByVisitSerial(this.diagnosis.filter(diagnosis => diagnosis.visitSerial == this.visitSerial));
      this.groupedVitals = this.groupByVisitSerial(this.vitals.filter(vital => vital.visitSerial == this.visitSerial));
      this.groupedComplaints = this.groupByVisitSerial(this.complaints.filter(complaints => complaints.visitSerial == this.visitSerial));
      this.groupedLabData = this.groupByVisitSerial(this.labData.filter(labData => labData.visitSerial == this.visitSerial));
      this.groupedRadData = this.groupByVisitSerial(this.radData.filter(radData => radData.visitSerial == this.visitSerial));
      this.groupedLeads = this.groupByVisitSerial(this.leads.filter(leads => leads.visitSerial == this.visitSerial));
      this.groupedFinding = this.groupByVisitSerial(this.finding.filter(finding => finding.visitSerial == this.visitSerial));
    }
    else {
      this.groupedMedications = this.groupByVisitSerial(this.medications);
      this.groupedLabData = this.groupByVisitSerial(this.labData);
      this.groupedRadData = this.groupByVisitSerial(this.radData);
      this.groupedComplaints = this.groupByVisitSerial(this.complaints);
      this.groupedDiagnosis = this.groupByVisitSerial(this.diagnosis);
      this.groupedVitals = this.groupByVisitSerial(this.vitals);
      this.groupedLeads = this.groupByVisitSerial(this.leads);
      this.groupedFinding = this.groupByVisitSerial(this.finding);
    }
  }


  //================================================================Eng/Mostafa Mahmoud =====================================================
  closeAllVists() {
    this.closeAllVisits.emit(true);
  }
  CopyDiagnosis(item: any) {
    let value = item.diagnosisDesc ? item.diagnosisDesc : item.notes;
    this.copyMessage(value)
  }
  Copycomplaint(item: any) {
    let value = item.complainDesc ? item.complainDesc : item.notes;
    this.copyMessage(value)
  }
  copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

}
